/* Country Road Fashions — the reels.

   Six muted films in a row would cost a page load six downloads. Each
   plays only while its tile is on screen and pauses when it leaves; the
   poster stands in until then. Under reduced motion nothing moves until
   the customer presses play, so a button is added to each frame. */
(function () {
  'use strict';

  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');

  function button(root, video) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'crf-social__play';
    b.setAttribute('data-state', 'paused');
    b.setAttribute('aria-label', root.getAttribute('data-play-label') || 'Play');
    b.innerHTML = '<svg class="icon-play" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 1l9 5-9 5z"/></svg>' +
      '<svg class="icon-pause" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 1h3v10H2zM7 1h3v10H7z"/></svg>';
    b.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        b.setAttribute('data-state', 'playing');
        b.setAttribute('aria-label', root.getAttribute('data-pause-label') || 'Pause');
      } else {
        video.pause();
        b.setAttribute('data-state', 'paused');
        b.setAttribute('aria-label', root.getAttribute('data-play-label') || 'Play');
      }
    });
    video.parentNode.appendChild(b);
  }

  function setup(root) {
    var films = root.querySelectorAll('video');
    if (!films.length) return;
    films.forEach(function (v) { v.muted = true; v.loop = true; v.playsInline = true; v.removeAttribute('autoplay'); });

    if (calm.matches) {
      films.forEach(function (v) { button(root, v); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { rootMargin: '120px 0px', threshold: 0.1 });
    films.forEach(function (v) { io.observe(v); });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) films.forEach(function (v) { v.pause(); });
    });
  }

  document.querySelectorAll('[data-crf-social]').forEach(setup);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-crf-social]').forEach(setup);
  });
}());
